/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PaginatedTeacherActivityList } from '../model/paginatedTeacherActivityList';
import { PatchedTeacherActivity } from '../model/patchedTeacherActivity';
import { TeacherActivity } from '../model/teacherActivity';
import { TeacherActivityCreate } from '../model/teacherActivityCreate';
import { TeacherActivityUpdate } from '../model/teacherActivityUpdate';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TeacherActivityService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start)
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherActivityCreate(body: TeacherActivityCreate, observe?: 'body', reportProgress?: boolean): Observable<TeacherActivity>;
    public teacherActivityCreate(body: TeacherActivityCreate, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherActivity>>;
    public teacherActivityCreate(body: TeacherActivityCreate, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherActivity>>;
    public teacherActivityCreate(body: TeacherActivityCreate, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling teacherActivityCreate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TeacherActivity>('post',`${this.basePath}/teacher-activity/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start)
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherActivityDestroy(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public teacherActivityDestroy(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public teacherActivityDestroy(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public teacherActivityDestroy(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling teacherActivityDestroy.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/teacher-activity/${encodeURIComponent(String(id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start)
     * @param id 
     * @param file 
     * @param title 
     * @param description 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherActivityDocumentCreateForm(id: string, file?: Blob, title?: string, description?: string, observe?: 'body', reportProgress?: boolean): Observable<TeacherActivity>;
    public teacherActivityDocumentCreateForm(id: string, file?: Blob, title?: string, description?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherActivity>>;
    public teacherActivityDocumentCreateForm(id: string, file?: Blob, title?: string, description?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherActivity>>;
    public teacherActivityDocumentCreateForm(id: string, file?: Blob, title?: string, description?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling teacherActivityDocumentCreate.');
        }




        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }
        if (title !== undefined) {
            formParams = formParams.append('title', <any>title) as any || formParams;
        }
        if (description !== undefined) {
            formParams = formParams.append('description', <any>description) as any || formParams;
        }

        return this.httpClient.request<TeacherActivity>('post',`${this.basePath}/teacher-activity/${encodeURIComponent(String(id))}/document/`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start)
     * @param activityHelped Aktivita mi pomohla rozvíjet mé profesní kompetence.  * &#x60;strongly_agree&#x60; - Rozhodně ano * &#x60;agree&#x60; - Spíše ano * &#x60;disagree&#x60; - Spíše ne * &#x60;strongly_disagree&#x60; - Rozhodně ne
     * @param activityType * &#x60;course&#x60; - Kurz * &#x60;workshop&#x60; - Workshop * &#x60;training&#x60; - Školení * &#x60;seminar&#x60; - Seminář * &#x60;webinar&#x60; - Webinář * &#x60;conference&#x60; - Konference * &#x60;publication&#x60; - Publikační / lektorská činnost * &#x60;project&#x60; - Projektová činnost * &#x60;internship&#x60; - Stáže / praxe * &#x60;self_study&#x60; - Samostudium * &#x60;volunteering&#x60; - Dobrovolnická činnost * &#x60;other&#x60; - Jiné
     * @param challengeExperienced Během aktivity jsem narazil/a na výzvu, která mě profesně posunula.  * &#x60;strongly_agree&#x60; - Rozhodně ano * &#x60;agree&#x60; - Spíše ano * &#x60;disagree&#x60; - Spíše ne * &#x60;strongly_disagree&#x60; - Rozhodně ne
     * @param dateEnd 
     * @param dateEndGte 
     * @param dateEndLte 
     * @param dateStart 
     * @param dateStartGte 
     * @param dateStartLte 
     * @param expectationsMet Aktivita naplnila má očekávání.  * &#x60;strongly_agree&#x60; - Rozhodně ano * &#x60;agree&#x60; - Spíše ano * &#x60;disagree&#x60; - Spíše ne * &#x60;strongly_disagree&#x60; - Rozhodně ne
     * @param feelsMoreConfident Po absolvování aktivity se cítím ve své roli pedagoga jistější.  * &#x60;strongly_agree&#x60; - Rozhodně ano * &#x60;agree&#x60; - Spíše ano * &#x60;disagree&#x60; - Spíše ne * &#x60;strongly_disagree&#x60; - Rozhodně ne
     * @param knowledgeUsage Získané poznatky mohu využít v každodenní praxi.  * &#x60;strongly_agree&#x60; - Rozhodně ano * &#x60;agree&#x60; - Spíše ano * &#x60;disagree&#x60; - Spíše ne * &#x60;strongly_disagree&#x60; - Rozhodně ne
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param ordering Which field to use when ordering the results.
     * @param recommendToOthers 
     * @param recordType * &#x60;private&#x60; - Soukromý * &#x60;shared&#x60; - Sdílený
     * @param search A search term.
     * @param selfPayer 
     * @param studyType * &#x60;in_person&#x60; - Prezenční * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Kombinované
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherActivityList(activityHelped?: string, activityType?: string, challengeExperienced?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, expectationsMet?: string, feelsMoreConfident?: string, knowledgeUsage?: string, limit?: number, offset?: number, ordering?: string, recommendToOthers?: boolean, recordType?: string, search?: string, selfPayer?: boolean, studyType?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedTeacherActivityList>;
    public teacherActivityList(activityHelped?: string, activityType?: string, challengeExperienced?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, expectationsMet?: string, feelsMoreConfident?: string, knowledgeUsage?: string, limit?: number, offset?: number, ordering?: string, recommendToOthers?: boolean, recordType?: string, search?: string, selfPayer?: boolean, studyType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedTeacherActivityList>>;
    public teacherActivityList(activityHelped?: string, activityType?: string, challengeExperienced?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, expectationsMet?: string, feelsMoreConfident?: string, knowledgeUsage?: string, limit?: number, offset?: number, ordering?: string, recommendToOthers?: boolean, recordType?: string, search?: string, selfPayer?: boolean, studyType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedTeacherActivityList>>;
    public teacherActivityList(activityHelped?: string, activityType?: string, challengeExperienced?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, expectationsMet?: string, feelsMoreConfident?: string, knowledgeUsage?: string, limit?: number, offset?: number, ordering?: string, recommendToOthers?: boolean, recordType?: string, search?: string, selfPayer?: boolean, studyType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (activityHelped !== undefined && activityHelped !== null) {
            queryParameters = queryParameters.set('activity_helped', <any>activityHelped);
        }
        if (activityType !== undefined && activityType !== null) {
            queryParameters = queryParameters.set('activity_type', <any>activityType);
        }
        if (challengeExperienced !== undefined && challengeExperienced !== null) {
            queryParameters = queryParameters.set('challenge_experienced', <any>challengeExperienced);
        }
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('date_end', <any>dateEnd);
        }
        if (dateEndGte !== undefined && dateEndGte !== null) {
            queryParameters = queryParameters.set('date_end__gte', <any>dateEndGte);
        }
        if (dateEndLte !== undefined && dateEndLte !== null) {
            queryParameters = queryParameters.set('date_end__lte', <any>dateEndLte);
        }
        if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('date_start', <any>dateStart);
        }
        if (dateStartGte !== undefined && dateStartGte !== null) {
            queryParameters = queryParameters.set('date_start__gte', <any>dateStartGte);
        }
        if (dateStartLte !== undefined && dateStartLte !== null) {
            queryParameters = queryParameters.set('date_start__lte', <any>dateStartLte);
        }
        if (expectationsMet !== undefined && expectationsMet !== null) {
            queryParameters = queryParameters.set('expectations_met', <any>expectationsMet);
        }
        if (feelsMoreConfident !== undefined && feelsMoreConfident !== null) {
            queryParameters = queryParameters.set('feels_more_confident', <any>feelsMoreConfident);
        }
        if (knowledgeUsage !== undefined && knowledgeUsage !== null) {
            queryParameters = queryParameters.set('knowledge_usage', <any>knowledgeUsage);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (recommendToOthers !== undefined && recommendToOthers !== null) {
            queryParameters = queryParameters.set('recommend_to_others', <any>recommendToOthers);
        }
        if (recordType !== undefined && recordType !== null) {
            queryParameters = queryParameters.set('record_type', <any>recordType);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (selfPayer !== undefined && selfPayer !== null) {
            queryParameters = queryParameters.set('self_payer', <any>selfPayer);
        }
        if (studyType !== undefined && studyType !== null) {
            queryParameters = queryParameters.set('study_type', <any>studyType);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedTeacherActivityList>('get',`${this.basePath}/teacher-activity/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start)
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherActivityPartialUpdate(id: string, body?: PatchedTeacherActivity, observe?: 'body', reportProgress?: boolean): Observable<TeacherActivity>;
    public teacherActivityPartialUpdate(id: string, body?: PatchedTeacherActivity, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherActivity>>;
    public teacherActivityPartialUpdate(id: string, body?: PatchedTeacherActivity, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherActivity>>;
    public teacherActivityPartialUpdate(id: string, body?: PatchedTeacherActivity, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling teacherActivityPartialUpdate.');
        }


        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TeacherActivity>('patch',`${this.basePath}/teacher-activity/${encodeURIComponent(String(id))}/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start)
     * @param id 
     * @param file 
     * @param title 
     * @param description 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherActivityPhotoCreateForm(id: string, file?: Blob, title?: string, description?: string, observe?: 'body', reportProgress?: boolean): Observable<TeacherActivity>;
    public teacherActivityPhotoCreateForm(id: string, file?: Blob, title?: string, description?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherActivity>>;
    public teacherActivityPhotoCreateForm(id: string, file?: Blob, title?: string, description?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherActivity>>;
    public teacherActivityPhotoCreateForm(id: string, file?: Blob, title?: string, description?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling teacherActivityPhotoCreate.');
        }




        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }
        if (title !== undefined) {
            formParams = formParams.append('title', <any>title) as any || formParams;
        }
        if (description !== undefined) {
            formParams = formParams.append('description', <any>description) as any || formParams;
        }

        return this.httpClient.request<TeacherActivity>('post',`${this.basePath}/teacher-activity/${encodeURIComponent(String(id))}/photo/`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start)
     * @param activityHelped Aktivita mi pomohla rozvíjet mé profesní kompetence.  * &#x60;strongly_agree&#x60; - Rozhodně ano * &#x60;agree&#x60; - Spíše ano * &#x60;disagree&#x60; - Spíše ne * &#x60;strongly_disagree&#x60; - Rozhodně ne
     * @param activityType * &#x60;course&#x60; - Kurz * &#x60;workshop&#x60; - Workshop * &#x60;training&#x60; - Školení * &#x60;seminar&#x60; - Seminář * &#x60;webinar&#x60; - Webinář * &#x60;conference&#x60; - Konference * &#x60;publication&#x60; - Publikační / lektorská činnost * &#x60;project&#x60; - Projektová činnost * &#x60;internship&#x60; - Stáže / praxe * &#x60;self_study&#x60; - Samostudium * &#x60;volunteering&#x60; - Dobrovolnická činnost * &#x60;other&#x60; - Jiné
     * @param challengeExperienced Během aktivity jsem narazil/a na výzvu, která mě profesně posunula.  * &#x60;strongly_agree&#x60; - Rozhodně ano * &#x60;agree&#x60; - Spíše ano * &#x60;disagree&#x60; - Spíše ne * &#x60;strongly_disagree&#x60; - Rozhodně ne
     * @param dateEnd 
     * @param dateEndGte 
     * @param dateEndLte 
     * @param dateStart 
     * @param dateStartGte 
     * @param dateStartLte 
     * @param expectationsMet Aktivita naplnila má očekávání.  * &#x60;strongly_agree&#x60; - Rozhodně ano * &#x60;agree&#x60; - Spíše ano * &#x60;disagree&#x60; - Spíše ne * &#x60;strongly_disagree&#x60; - Rozhodně ne
     * @param feelsMoreConfident Po absolvování aktivity se cítím ve své roli pedagoga jistější.  * &#x60;strongly_agree&#x60; - Rozhodně ano * &#x60;agree&#x60; - Spíše ano * &#x60;disagree&#x60; - Spíše ne * &#x60;strongly_disagree&#x60; - Rozhodně ne
     * @param knowledgeUsage Získané poznatky mohu využít v každodenní praxi.  * &#x60;strongly_agree&#x60; - Rozhodně ano * &#x60;agree&#x60; - Spíše ano * &#x60;disagree&#x60; - Spíše ne * &#x60;strongly_disagree&#x60; - Rozhodně ne
     * @param ordering Which field to use when ordering the results.
     * @param recommendToOthers 
     * @param recordType * &#x60;private&#x60; - Soukromý * &#x60;shared&#x60; - Sdílený
     * @param search A search term.
     * @param selfPayer 
     * @param studyType * &#x60;in_person&#x60; - Prezenční * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Kombinované
     * @param type Export type: &#x27;csv&#x27; or &#x27;xlsx&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherActivityPrintRetrieve(activityHelped?: string, activityType?: string, challengeExperienced?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, expectationsMet?: string, feelsMoreConfident?: string, knowledgeUsage?: string, ordering?: string, recommendToOthers?: boolean, recordType?: string, search?: string, selfPayer?: boolean, studyType?: string, type?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public teacherActivityPrintRetrieve(activityHelped?: string, activityType?: string, challengeExperienced?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, expectationsMet?: string, feelsMoreConfident?: string, knowledgeUsage?: string, ordering?: string, recommendToOthers?: boolean, recordType?: string, search?: string, selfPayer?: boolean, studyType?: string, type?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public teacherActivityPrintRetrieve(activityHelped?: string, activityType?: string, challengeExperienced?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, expectationsMet?: string, feelsMoreConfident?: string, knowledgeUsage?: string, ordering?: string, recommendToOthers?: boolean, recordType?: string, search?: string, selfPayer?: boolean, studyType?: string, type?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public teacherActivityPrintRetrieve(activityHelped?: string, activityType?: string, challengeExperienced?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, expectationsMet?: string, feelsMoreConfident?: string, knowledgeUsage?: string, ordering?: string, recommendToOthers?: boolean, recordType?: string, search?: string, selfPayer?: boolean, studyType?: string, type?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (activityHelped !== undefined && activityHelped !== null) {
            queryParameters = queryParameters.set('activity_helped', <any>activityHelped);
        }
        if (activityType !== undefined && activityType !== null) {
            queryParameters = queryParameters.set('activity_type', <any>activityType);
        }
        if (challengeExperienced !== undefined && challengeExperienced !== null) {
            queryParameters = queryParameters.set('challenge_experienced', <any>challengeExperienced);
        }
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('date_end', <any>dateEnd);
        }
        if (dateEndGte !== undefined && dateEndGte !== null) {
            queryParameters = queryParameters.set('date_end__gte', <any>dateEndGte);
        }
        if (dateEndLte !== undefined && dateEndLte !== null) {
            queryParameters = queryParameters.set('date_end__lte', <any>dateEndLte);
        }
        if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('date_start', <any>dateStart);
        }
        if (dateStartGte !== undefined && dateStartGte !== null) {
            queryParameters = queryParameters.set('date_start__gte', <any>dateStartGte);
        }
        if (dateStartLte !== undefined && dateStartLte !== null) {
            queryParameters = queryParameters.set('date_start__lte', <any>dateStartLte);
        }
        if (expectationsMet !== undefined && expectationsMet !== null) {
            queryParameters = queryParameters.set('expectations_met', <any>expectationsMet);
        }
        if (feelsMoreConfident !== undefined && feelsMoreConfident !== null) {
            queryParameters = queryParameters.set('feels_more_confident', <any>feelsMoreConfident);
        }
        if (knowledgeUsage !== undefined && knowledgeUsage !== null) {
            queryParameters = queryParameters.set('knowledge_usage', <any>knowledgeUsage);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (recommendToOthers !== undefined && recommendToOthers !== null) {
            queryParameters = queryParameters.set('recommend_to_others', <any>recommendToOthers);
        }
        if (recordType !== undefined && recordType !== null) {
            queryParameters = queryParameters.set('record_type', <any>recordType);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (selfPayer !== undefined && selfPayer !== null) {
            queryParameters = queryParameters.set('self_payer', <any>selfPayer);
        }
        if (studyType !== undefined && studyType !== null) {
            queryParameters = queryParameters.set('study_type', <any>studyType);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request('get',`${this.basePath}/teacher-activity/print/`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start)
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherActivityRetrieve(id: string, observe?: 'body', reportProgress?: boolean): Observable<TeacherActivity>;
    public teacherActivityRetrieve(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherActivity>>;
    public teacherActivityRetrieve(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherActivity>>;
    public teacherActivityRetrieve(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling teacherActivityRetrieve.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TeacherActivity>('get',`${this.basePath}/teacher-activity/${encodeURIComponent(String(id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start)
     * @param body 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherActivityUpdate(body: TeacherActivityUpdate, id: string, observe?: 'body', reportProgress?: boolean): Observable<TeacherActivity>;
    public teacherActivityUpdate(body: TeacherActivityUpdate, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherActivity>>;
    public teacherActivityUpdate(body: TeacherActivityUpdate, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherActivity>>;
    public teacherActivityUpdate(body: TeacherActivityUpdate, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling teacherActivityUpdate.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling teacherActivityUpdate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TeacherActivity>('put',`${this.basePath}/teacher-activity/${encodeURIComponent(String(id))}/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
